interface UpiIntentOption {
  value: string;
  label: string;
}

export const upiAppOptions: UpiIntentOption[] = [
  {
    value: 'gpay',
    label: 'Google Pay',
  },
  {
    value: 'phonepe',
    label: 'PhonePe',
  },
  {
    value: 'paytm',
    label: 'Paytm',
  },
  {
    value: 'bhim',
    label: 'Bhim',
  },
] as const;
